var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPalette(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11108_86737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0V20C15.5229 20 20 15.5229 20 10C20 4.47714 15.5229 0 10 0Z",
    fill: "#FFB17B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7928 10C18.7928 4.47714 14.8561 0 10 0C4.47714 0 0 4.47714 0 10C0 12.428 1.96833 14.3964 4.39638 14.3964C5.06314 14.3964 5.60362 14.9369 5.60362 15.6036C5.60362 18.0317 7.57195 20 10 20C14.8561 20 18.7928 15.5229 18.7928 10ZM4.39638 12.5855C2.96845 12.5855 1.81087 11.4279 1.81087 10C1.81087 8.57207 2.96845 7.41449 4.39638 7.41449C5.82431 7.41449 6.98189 8.57207 6.98189 10C6.98189 11.4279 5.82431 12.5855 4.39638 12.5855Z",
    fill: "#FFD19C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2805 1.73741C10.9269 1.38381 10.4634 1.20703 10 1.20703L10.3205 4.50462C10.6431 4.62623 11.0208 4.55798 11.2805 4.29838C11.9876 3.59118 11.9876 2.44462 11.2805 1.73741Z",
    fill: "#077CCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4272 1.73741C10.3093 1.38381 10.1548 1.20703 10.0003 1.20703C9.53688 1.20703 9.07346 1.38381 8.71986 1.73741C8.01265 2.44462 8.01265 3.59118 8.71986 4.29838C9.07346 4.65198 9.64674 4.65198 10.0003 4.29838C10.0943 4.39234 10.204 4.46059 10.3208 4.50462C10.3596 4.46059 10.396 4.39202 10.4272 4.29838C10.6629 3.59118 10.6629 2.44462 10.4272 1.73741Z",
    fill: "#09A1E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2805 18.2621C10.9269 18.6157 10.4635 18.7925 10 18.7925L10.3205 15.4949C10.6431 15.3733 11.0208 15.4415 11.2805 15.7011C11.9876 16.4083 11.9876 17.5549 11.2805 18.2621Z",
    fill: "#CB2E81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4272 18.2627C10.3093 18.6163 10.1548 18.7931 10.0003 18.7931C9.53688 18.7931 9.07346 18.6163 8.71986 18.2627C8.01265 17.5555 8.01265 16.4089 8.71986 15.7017C9.07346 15.3481 9.64674 15.3481 10.0003 15.7017C10.0943 15.6078 10.204 15.5395 10.3208 15.4955C10.3596 15.5395 10.396 15.6081 10.4272 15.7017C10.6629 16.4089 10.6629 17.5555 10.4272 18.2627Z",
    fill: "#FF3187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9365 16.7477V13.126C15.9366 13.126 16.7474 13.9367 16.7474 14.9368C16.7474 15.937 15.9366 16.7477 14.9365 16.7477Z",
    fill: "#FF7169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5405 14.9368C15.5405 15.937 15.2702 16.7477 14.9368 16.7477C13.9367 16.7477 13.126 15.937 13.126 14.9368C13.126 14.4368 13.5313 14.0314 14.0314 14.0314C14.0314 13.5314 14.4368 13.126 14.9368 13.126C15.2702 13.126 15.5405 13.9367 15.5405 14.9368Z",
    fill: "#FF9259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2619 8.71984C17.9083 8.36623 17.4449 8.18945 16.9814 8.18945V11.8112C17.4449 11.8112 17.9083 11.6344 18.2619 11.2808C18.9691 10.5736 18.9691 9.42704 18.2619 8.71984Z",
    fill: "#FF9259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5858 10.0003C17.5858 9.0002 17.3156 8.18945 16.9822 8.18945C16.5187 8.18945 16.0553 8.36623 15.7017 8.71984C15.3481 9.07344 15.3481 9.64672 15.7017 10.0003C15.3481 10.3539 15.3481 10.9272 15.7017 11.2808C16.0553 11.6344 16.5187 11.8112 16.9822 11.8112C17.3156 11.8112 17.5858 11.0004 17.5858 10.0003Z",
    fill: "#FFB24A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9365 3.25195V6.87368C15.9366 6.87368 16.7474 6.06294 16.7474 5.06282C16.7474 4.0627 15.9366 3.25195 14.9365 3.25195Z",
    fill: "#49B296"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5405 5.06282C15.5405 4.0627 15.2702 3.25195 14.9368 3.25195C13.9367 3.25195 13.126 4.0627 13.126 5.06282C13.126 5.56286 13.5313 5.96825 14.0314 5.96825C14.0314 6.46829 14.4368 6.87368 14.9368 6.87368C15.2702 6.87368 15.5405 6.06294 15.5405 5.06282Z",
    fill: "#89C247"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11108_86737"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalette);
export default __webpack_public_path__ + "static/media/Palette.efefd5909de85783f9fbed7f6f581a9e.svg";
export { ForwardRef as ReactComponent };